import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Login from './Login';
import Game from './Game';
import RankingsPage from './RankingsPage';
import CreateRoom from './CreateRoom';
import UsernameSelection from './UsernameSelection';
import TutorialScreen from './TutorialScreen';
import ArcadeLevelSelect from './arcade/ArcadeLevelSelect';
import ArcadeIntro from './arcade/ArcadeIntro';
import ArcadeGame from './arcade/ArcadeGame';
import { ThemeProvider } from './ThemeContext';

const App = () => {

  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser) : null;
  });

  useEffect(() => {
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    } else {
      localStorage.removeItem('user');
    }
  }, [user]);

  return (
    <ThemeProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Login setUser={setUser} />} />
          <Route path="/game" element={<Game user={user} />} />
          <Route path="/rankings" element={<RankingsPage user={user} />} />
          <Route path="/room-creation" element={<CreateRoom />} />
          <Route path="/username-selection" element={<UsernameSelection />} />
          <Route path="/tutorial" element={<TutorialScreen />} />
          <Route path="/arcade" element={<ArcadeLevelSelect />} />
          <Route path="/arcade/:levelId" element={<ArcadeIntro />} />
          <Route path="/arcade/game/:levelId" element={<ArcadeGame />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
};

export default App;
